<template>
  <button
    class="content-partner-card-component"
    @click="$emit('card-clicked', contentPartner)"
  >
    <img
      v-if="featuredImage"
      :src="featuredImage.url"
      :alt="featuredImageAltText"
      class="featured-image"
    />
    <div class="card-content">
      <p class="partner-name">
        {{ contentPartner.name }}
      </p>
      <p class="partner-asset-count">
        {{ assetCount.total }} Items
      </p>
      <div class="partner-description">
        <span
          v-html="contentPartner.descriptionHtml"
        />

        <div class="overlay" />
      </div>
    </div>
    <follow-button
      class="card-follow-button"
      :content-partner-id="contentPartner.id"
    />
  </button>
</template>

<script>
import FollowButton from '@components/singletons/follow-button';
export default {
  name: 'ContentPartnerCard',
  components: { FollowButton },
  props: {
    assetCount: {
      type: Object,
    },
    contentPartner: {
      type: Object,
    },
    featuredImage: {
      type: Object,
    },
  },
  computed: {
    featuredImageAltText() {
      return `Featured image representing ${this.contentPartner.name}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.content-partner-card-component {
  @include shadowed;
  background: #ffffff;
  border-radius: 8px;
  padding: 0;
  position: relative;
  text-align: left;

  .featured-image {
    border-radius: 8px 8px 0 0;
    height: rem-calc(128);
    object-fit: cover;
    object-position: center;
    width: 100%;
  }

  .card-content {
    padding: rem-calc(16) rem-calc(16) rem-calc(48);

    .partner-name,
    .partner-asset-count {
      margin: 0;
    }

    .partner-name {
      font-weight: $semi-bold;
    }

    .partner-asset-count {
      color: #767676;
      font-size: rem-calc(12);
      text-transform: uppercase;
    }

    .partner-description {
      font-size: rem-calc(14);
      height: rem-calc(96);
      margin-top: rem-calc(16);
      overflow: hidden;
      position: relative;

      .overlay {
        height: 100%;
        width: 100%;
        background: linear-gradient(rgba(255, 255, 255, 0), rgba(255,255,255, 1));
        position: absolute;
        top: 0;
      }
    }
  }

  .card-follow-button {
    position: absolute;
    bottom: 16px;
    right: 16px;
  }
}
</style>